import { lazy } from "react";
import { useRoutes, Navigate } from "react-router-dom";
import Layout from "../layout";
import { Login } from "../components/Login";
import { AuthProvider } from "../auth";
import HeaderComponent from "../components/Header";
import { AppProvider } from "../components/Header/context";
import { FormProgressProvider } from "../components/Header/form-progress-context";
import { PrivacyPolicy } from "../pages/PrivacyPolicy";
import { TermsAndConditions } from "../pages/TermsAndConditions";

const Dashboard = lazy(() => import("../components/Dashboard/"));
const Onboarding = lazy(() => import("../components/Onboarding/"));
const HelpCentre = lazy(() => import("../components/HelpCentre/"));
const HelpServices = lazy(() => import("../components/HelpCentre/HelpServices"));
const HelpArticlePage = lazy(
  () => import("../components/HelpCentre/HelpArticlePage")
);
const Forms = lazy(() => import("../components/FormComponent/ClinicalForms"));
const ParentConsent = lazy(() => import("../components/ParentConsent/"));
const EthicsConsent = lazy(() => import("../components/EthicsConsent/"));

const useRenderRoutes = () =>
  useRoutes([
    {
      path: "consent/:code",
      element: <ParentConsent />,
    },
    {
      path: "ethics-consent/:type/:code",
      element: <EthicsConsent />,
    },
    {
      element: (
        <AuthProvider>
          <AppProvider>
            {/* Wraps both, so the header knows when a form is part-completed and can warn first. */}
            <FormProgressProvider>
              <HeaderComponent />
              <Layout />
            </FormProgressProvider>
          </AppProvider>
        </AuthProvider>
      ),
      children: [
        {
          index: true,
          element: <Dashboard />,
        },
        {
          path: "forms/:formId/:responseId",
          element: <Forms />,
        },
        {
          path: "forms/:formId",
          element: <Forms />,
        },
        {
          path: "login",
          element: <Login />,
        },
        {
          path: "login/:actor",
          element: <Login />,
        },
        {
          path: "onboarding",
          element: <Onboarding />,
        },
        {
          path: "help",
          element: <HelpServices />,
        },
        {
          path: "help/:section",
          element: <HelpCentre />,
        },
        {
          path: "help/:section/:slug",
          element: <HelpArticlePage />,
        },
        {
          path: "privacy-policy",
          element: <PrivacyPolicy />,
        },
        {
          path: "terms-and-conditions",
          element: <TermsAndConditions />,
        },
      ],
    },
    {
      path: "*",
      element: <Navigate to="/" replace />,
    },
  ]);

const renderRoutes = { useRenderRoutes };

export default renderRoutes;
